/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'navigation/forward-white': {
    width: 16,
    height: 16,
    viewBox: '0 0 34 34',
    data: '<g data-name="Layer 2"><g data-name="Layer 1"><path pid="0" _fill="#e25046" d="M0 0h34v34H0z"/><path pid="1" d="M17 6.5L7 15.37v5l8-7.1V27.5h4V13.29l8 7.1v-5z" _fill="#fff"/></g></g>'
  }
})
